import { render } from "./PaymentMethodsDisplay.vue?vue&type=template&id=4e057695&ts=true"
import script from "./PaymentMethodsDisplay.vue?vue&type=script&lang=ts"
export * from "./PaymentMethodsDisplay.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__